import {
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";

export default function VendorCard({ data, callBack, incentiveName }) {
  return (
    <Card
      sx={{
        width: "100%",
        m: "0px",
        mt: "10px",
        p: "10px",

        cursor: "pointer",
        ":hover": {
          bgcolor: "#2892ba17",
        },
      }}
      onClick={() => {
        callBack(data);
      }}
      //   onClick={setEditedItem}
    >
      <CardContent sx={{ p: "0px 10px !important" }}>
        <Grid container>
          <Grid item xs={8}>
            <Typography
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },

                overflow: "Hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                "-webkit-line-clamp": "1",
                "-webkit-box-orient": "vertical",
                fontWeight: 600,
              }}
            >
              {data?.vendorName}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
